/**
 * An enumeration that defines WebSocket events.
 *
 * @readonly
 * @enum {string}
 */
export enum EWebSocketEvent {
  Connect = 'connect',
  Ping = 'ping',
  Pong = 'pong',
  ConnectToRoom = 'connectToRoom',
  TranscriptionsToTranslate = 'transcriptions-to-translate',
  TranscriptionsWithTranslate = 'transcriptions-with-translate',
  TranscriptionsStatusChanges = 'transcription-status-changed',
  Whiteboard = 'whiteboard',
  ApproveCall = 'approve-call',
  ChatMessage = 'chat-message',
  ChatMessageRead = 'chat-message-read',
  AuthorizationRequestUpdated = 'authorization-request-updated',
  NeedToUpdateCallPayment = 'need-to-update-call-payment',
  EndCall = 'end-call',
  ForceEndCall = 'force-end-call',
  EndBusinessUserCall = 'end-business-user-call',
  RerouteCall = 'reroute-call',
}
